module.exports = __webpack_public_path__ + "static/assets/a420650600c087357d0a6ee498557500.png";